import { render, staticRenderFns } from "./BranchTime.vue?vue&type=template&id=1127bcac&scoped=true&"
import script from "./BranchTime.vue?vue&type=script&lang=js&"
export * from "./BranchTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127bcac",
  null
  
)

export default component.exports